const Homepage = () => {
  return ("");
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/Pages/Homepage.js